import { Button, ButtonGroup, Heading, Paragraph, Text, TextButton } from '@zillow/constellation-10';

import LeaseModal from '../../Containers/LeaseModal';
import type { LeaseActionProps } from '../../../../shared/models/Types';
import FaqAccordion from '../../Widgets/FaqAccordion';
import LeaseExtension from '../../../models/LeaseExtension';
import { useLeasingUrlParams } from '../../../hooks/useLeasingUrlParams';

const FAQ_SECTIONS = [
  {
    label: 'How can my renters and I sign the lease renewal agreement?',
    description: (
      <Text>
        Once you finish creating a draft of your lease renewal agreement, request signatures from your leases dashboard.
      </Text>
    ),
  },
  {
    label: 'How do I share a draft with people who aren’t my tenants, such as my lawyer?',
    description: (
      <Text>
        After you finish creating a draft of your lease renewal agreement, download a PDF. You can email or text that
        file to your recipients. If you prefer, you can also print a copy and share it via regular mail or in person.
      </Text>
    ),
  },
];

export default function OpenModalRequestSignaturesLeaseExtensionBlocker({
  history,
  terminateActiveAction,
  lease,
}: LeaseActionProps): JSX.Element {
  const latestExtension = lease?.latestExtension ? new LeaseExtension(lease.latestExtension) : null;
  const { renewalId, leaseId } = useLeasingUrlParams();

  const extensionId = renewalId || latestExtension?.id || 0;

  function onEditLease(): void {
    terminateActiveAction();
    history.push(LeaseExtension.getWizardPath(leaseId || lease.id, extensionId));
  }

  return (
    <LeaseModal
      header={<Heading level={1}>Your lease renewal is not complete</Heading>}
      isOpen
      onClose={terminateActiveAction}
      body={
        <>
          <Paragraph css={{ marginBottom: 'tight' }}>
            To download a draft or to share one with your renters, complete the fields that need more info.
          </Paragraph>
          <FaqAccordion title="You may be wondering…" sections={FAQ_SECTIONS} />
        </>
      }
      footer={
        <ButtonGroup aria-label="finish lease renewal actions">
          <TextButton tone="brand" onClick={terminateActiveAction}>
            Cancel
          </TextButton>
          <Button tone="brand" emphasis="filled" onClick={onEditLease}>
            Finish creating my lease renewal
          </Button>
        </ButtonGroup>
      }
    />
  );
}
